import { replacePlaceholders } from "./helper";
import ERROR_MESSAGE_COPIES from '@/constants/error-messages/index';

/**
 * Returns the error message for a pattern validation error.
 * @param fieldScheme The field's schema object
 * @param data The input data
 */
export function getPatternErrorMessage(fieldScheme, data) {
    if (!fieldScheme) return '';
   /* const BANNED_SPECIAL_CHARACTERS = /[!@#$%^&*()_+={}\[\]|\\:;"'<>,.?/~`]/;
    if (BANNED_SPECIAL_CHARACTERS.test(data)) {
        return ERROR_MESSAGE_COPIES.pattern.specialCharacters;
    }*/
    if (
        typeof data === 'string' &&
        typeof fieldScheme.minLength === 'number' &&
        typeof fieldScheme.maxLength === 'number' &&
        fieldScheme.minLength !== fieldScheme.maxLength &&
        (data.length < fieldScheme.minLength || data.length > fieldScheme.maxLength)
    ) {
        return replacePlaceholders(
            ERROR_MESSAGE_COPIES.pattern.valueWithMinMaxLength,
            fieldScheme.minLength,
            fieldScheme.maxLength,
            fieldScheme.description
        );
    }
    else{
        return replacePlaceholders(
            ERROR_MESSAGE_COPIES.pattern.onlyValue,
            fieldScheme.description,
        );
    }
}
